<div class="table-responsive">
    <table class="table basictable row-border hover" datatable [dtOptions]="dtOptions">
        <thead>
            <tr>
                <th>Portfolio/Tenant</th>
                <th>Matching Records</th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let item of list;let i = index ">
                <tr>
                    <td><p>{{item.SFOpportunityName}}</p></td>
                    <td class="whitespacenowrap">
                        <p class="d-flex">
                            <span (click)="showDetails(item.ProspectId,i)" class="btn-collapse" [class.span-open]="list[i].showDetails">
                                <i class="fa fa-angle-right" aria-hidden="true"></i>
                            </span>
                            {{item.MatchingRecords}} Matching Records
                        </p>
                    </td>
                    <td>
                    </td>
                </tr>
                <ng-container *ngIf="list[i].showDetails">
                    <tr *ngFor="let child of item.Details; let k=index" [class.tr-collapse]="list[i].showDetails">
                        <td>
                            <p>
                                <a href="javascript:void(0);" routerLink="/viewproperty/{{child.Guid}}" [queryParams]="{'prevroute':'Pending Approval',link:'pending-approval-list'}"> {{child.SFOpportunityName}}</a>
                            </p>
                        </td>
                        <td>-</td>
                        <td>
                            <p>
                                <a href="javascript:void(0);" (click)="openModalForLinking(LinkPortfolio,'deletemodal',item.ProspectId,child.PropertyId)" tooltip="Link" placement="top">
                                    Link
                                </a>
                            </p>
                        </td>
                    </tr>
                </ng-container>
            </ng-container>
        </tbody>
        <tfoot>
            <tr *ngIf="list?.length == 0 ">
                <td colspan="3" class="odd no-data-available">
                    <div class="nodata">
                        <i class="fa fa-exclamation-triangle icon"></i>
                        <p>No Data Available</p>
                    </div>
                </td>
            </tr>
        </tfoot>
    </table>
</div>

<ng-template #LinkPortfolio>
    <div class="modal-header">
        <h4 class="modal-title pull-left">Link Portfolio</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body padding30">
        <div class="form-group">
            <h6 class="displayvalue">Are you sure to link this portfolio ?</h6>
        </div>
        <div class="text-right">
            <button class="btn btn-lg btn-default" (click)="modalRef.hide()">Cancel</button>
            <button class="btn btn-lg btn-success" (click)="linkPortfolio();modalRef.hide();">Link</button>
        </div>
    </div>

</ng-template>